import Input, { InputLabel, InputAdornment } from "material-ui/Input";

export default Input;
export { InputLabel, InputAdornment };



// WEBPACK FOOTER //
// ./src/components/uielements/input/index.js